<template>
  <div class="body-container">
    <div class="box">
      <h2>找回登录密码</h2>
      <div class="forget-password-form" v-show="step === 1">
        <el-form
          :model="forgetForm"
          :rules="forgetRule"
          ref="forgetForm"
          class="login-form"
          @submit.native.prevent
        >
          <el-form-item prop="mobile">
            <el-input
              v-model="forgetForm.mobile"
              ref="mobile"
              placeholder="请输入手机号"
              :maxlength="11"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-row>
              <el-col :span="15" style="width: 220px">
                <el-input
                  v-model="forgetForm.code"
                  placeholder="请输入验证码"
                  :maxlength="6"
                ></el-input>
              </el-col>
              <el-col :span="9">
                <div class="send-btn" :class="{ disabled: !canSendSms }">
                  <el-button
                    type="text"
                    :disabled="!canSendSms"
                    @click="sendSms()"
                    >{{ sendSmsInfo }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
            <div class="el-form-item__error" v-if="isSendSms">
              验证码已发送到你的手机，10分钟内输入有效
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="form-btn"
              native-type="submit"
              @click="submitForgetForm('forgetForm')"
              >下一步</el-button
            >
          </el-form-item>
          <div class="btns-link">
            <router-link to="/login" class="back-login-link"
              >返回登录</router-link
            >
          </div>
        </el-form>
      </div>
      <div class="forget-password-form" v-show="step === 2">
        <el-form
          :model="resetForm"
          :rules="resetRule"
          @submit.native.prevent
          ref="resetForm"
          class="login-form"
        >
          <el-form-item prop="new_password">
            <el-input
              type="password"
              v-model="resetForm.new_password"
              placeholder="新密码由数字和字母组成"
              :maxlength="30"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="new_password2">
            <el-input
              type="password"
              v-model="resetForm.new_password2"
              placeholder="再次确认新密码"
              :maxlength="30"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="form-btn"
              native-type="submit"
              @click="submitResetForm('resetForm')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EnvConfig from "@/const/configs/env.config.js";
import { CommonHelper } from "@/utils/common.helper.js";

export default {
  name: "ros-forget",
  data() {
    const validateVerifyMobile = (rule, value, callback) => {
      if (/^1[0-9]{10,10}$/.test(value)) {
        axios
          .get(EnvConfig.JAVA_BASE_ADDR + "/v1/saas/Sites/verifyMobile", {
            params: { mobile: value },
          })
          .then((response) => {
            if (response.data.code === 0 && !response.data.data) {
              this.$data.canSendSms = false;
              callback(new Error("手机号不存在，请重新输入"));
            } else {
              this.refreshCaptcha();
              callback();
            }
          });
      } else if (!/^1[0-9]{10,10}$/.test(value)) {
        this.$data.canSendSms = false;
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (!value) {
        this.$data.isSendSms = false;
        callback(new Error("短信验证码不能为空"));
      } else {
        callback();
      }
    };
    const validateNewPassword = (rule, value, callback) => {
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,30}$/.test(value)) {
        callback(new Error("新密码由数字和字母组合"));
      } else if (value.length < 6) {
        callback(new Error("新密码最少6位字符"));
      } else {
        callback();
      }
    };
    const validateNewPassword2 = (rule, value, callback) => {
      if (this.$data.resetForm.new_password !== value) {
        return callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      step: 1,
      intervalSms: null,
      isSendSms: false,
      sendSmsInfo: "获取短信验证码",
      smsCountDown: 0,
      canSendSms: false,
      forgetForm: {
        mobile: "",
        code: "",
      },
      forgetRule: {
        mobile: [{ validator: validateVerifyMobile, trigger: "change" }],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      resetForm: {
        mobile: "",
        code: "",
        new_password: "",
        new_password2: "",
      },
      resetRule: {
        new_password: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { validator: validateNewPassword, trigger: "blur" },
        ],
        new_password2: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { validator: validateNewPassword2, trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.$refs.mobile.focus();
  },
  methods: {
    sendSms() {
      const codeField = this.$refs["forgetForm"].fields[1];
      if (codeField.validateState) {
        codeField.resetField();
      }
      this.$data.canSendSms = false;
      const params = {
        mobile: this.$refs["forgetForm"].model.mobile,
        type: 2,
      };
      axios
        .post(EnvConfig.JAVA_BASE_ADDR + "/v1/saas/SmsCodeLogs", params)
        .then((response) => {
          if (response.data.code === 0) {
            this.$data.isSendSms = true;
            this.$data.smsCountDown = 60;
            this.$data.sendSmsInfo = "60秒后重新获取";
            this.$data.intervalSms = setInterval(() => {
              this.$data.smsCountDown--;
              this.$data.sendSmsInfo = this.$data.smsCountDown + "秒后重新获取";
              if (this.smsCountDown <= 0) {
                this.$data.canSendSms = true;
                this.$data.sendSmsInfo = "获取短信验证码";
                clearInterval(this.$data.intervalSms);
              }
            }, 1000);
          } else {
            this.$alert(response.data.message, "", {
              customClass: "alert-login-error",
              type: "error",
              confirmButtonText: "确认",
            });
          }
        });
    },
    refreshCaptcha() {
      this.$data.canSendSms = this.$data.smsCountDown <= 0;
    },
    submitForgetForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            mobile: this.$refs[formName].model.mobile,
            code: this.$refs[formName].model.code,
            type: 2,
          };
          axios
            .post(
              EnvConfig.JAVA_BASE_ADDR + "/v1/saas/Users/verifyCode",
              params
            )
            .then((response) => {
              if (response.data.code === 0) {
                this.$data.step = 2;
              } else {
                this.$alert(response.data.message, "", {
                  customClass: "alert-login-error",
                  type: "error",
                  confirmButtonText: "确定",
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    submitResetForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            mobile: this.$data.forgetForm.mobile,
            code: this.$data.forgetForm.code,
            new_password: CommonHelper.encypt(
              this.$refs[formName].model.new_password
            ),
            new_password2: CommonHelper.encypt(
              this.$refs[formName].model.new_password2
            ),
          };
          axios
            .post(
              EnvConfig.JAVA_BASE_ADDR + "/v1/saas/Users/FindPassword",
              params
            )
            .then((response) => {
              if (response.data.code === 0) {
                this.$alert("恭喜您，密码重置成功！", "", {
                  customClass: "alert-login-error",
                  type: "success",
                  confirmButtonText: "去登录",
                  callback: () => {
                    this.$router.push("/login");
                  },
                });
              } else {
                this.$alert(response.data.message, "", {
                  customClass: "alert-login-error",
                  type: "error",
                  confirmButtonText: "我知道",
                });
              }
            })
            .catch((error) => {
              this.$data.registering = false;
              this.$alert("服务器繁忙！请重试", "", {
                customClass: "alert-login-error",
                type: "error",
                confirmButtonText: "确定",
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.btns-link {
  text-align: right;

  .back-login-link {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
}
</style>
